import {
  INIT_COMPLETE_PREFERENCES,
  normalizeCompletePreferences,
} from "./completePreferences";
import { getPlatformCurrency, normalizeCurrency } from "./currency";
import { getRegistroTimestamp } from "./dateUtils";

export const toCents = (value) => {
  const number = Number(String(value || "0").replace(",", "."));
  return Number.isFinite(number) && number > 0 ? Math.round(number * 100) : 0;
};

export const fromCents = (value) => {
  const number = Number(value || 0) / 100;
  return Number.isInteger(number) ? String(number) : String(number.toFixed(2));
};

export const toEntryCount = (value) => {
  const count = Number(value || 1);
  return Number.isFinite(count) && count >= 1 ? Math.floor(count) : 1;
};

export const toNullableCents = (value) => {
  if (value === "" || value == null) return null;
  return toCents(value);
};

export const mapTournamentFromDb = (row, options = {}) => {
  const naturalCurrency = getPlatformCurrency(row.platform);

  return {
    id: row.tournament_id,
    source: options.source || "user",
    nome: row.name,
    buyin: fromCents(row.buy_in_cents),
    buyinCurrency: normalizeCurrency(row.buy_in_currency, naturalCurrency),
    plataforma: row.platform || "",
    modalidade: row.kind || "Vanilla",
    players: row.total_players ? String(row.total_players) : "",
    valorTicket:
      row.kind === "SAT" || row.ticket_value_cents
        ? fromCents(row.ticket_value_cents)
        : "",
    ticketValueCurrency: normalizeCurrency(
      row.ticket_value_currency,
      naturalCurrency
    ),
    criadoEm: row.created_at || new Date().toISOString(),
  };
};

export const mapEntryFromDb = (row) => ({
  id: row.register_id,
  torneioId: row.user_tournament_id || row.common_tournament_id,
  inscricoes: String(toEntryCount(row.entry_count)),
  premiacao: fromCents(row.prize_cents),
  prizeCurrency: normalizeCurrency(row.prize_currency, ""),
  tickets: fromCents(row.ticket_prize_cents),
  isSatellite: Boolean(row.is_sat),
  deletedAt: row.deleted_at || null,
  registradoEm: getRegistroTimestamp({
    createdAt: row.created_at,
    playedAt: row.played_at,
  }),
});

export const mapCompletePreferencesFromDb = (row) =>
  normalizeCompletePreferences({
    platforms: row?.platforms || [],
    buyInMin:
      row?.buy_in_min_cents == null
        ? row?.abi_min_cents == null
          ? ""
          : fromCents(row.abi_min_cents)
        : fromCents(row.buy_in_min_cents),
    buyInMax:
      row?.buy_in_max_cents == null
        ? row?.abi_max_cents == null
          ? ""
          : fromCents(row.abi_max_cents)
        : fromCents(row.buy_in_max_cents),
    onboardingCompletedAt: row?.onboarding_completed_at || null,
    hasSavedPreferences: Boolean(row),
  });

export const cloneCompletePreferences = (preferences) =>
  normalizeCompletePreferences(preferences || INIT_COMPLETE_PREFERENCES);
